import { useEffect, useState } from 'react';
import axios from 'axios';
import Footer from '../../../../../components/Footer/Footer';
import InnerNav from '../../../../../components/InnerNav/InnerNav';
import './BasicDetails.scss';
import { useFormData } from '../../ContextData/ContextData';

const BasicDetails = () => {

   const {userData} = useFormData();

  const [personDetails, setPersonDetails] = useState([]);
  const [avkahadaChakra, setAvkahadaChakra] = useState([]);
  const [favourablePoints, setFavourablePoints] = useState([]);
  const [ghatakMalefics, setGhatakMalefics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBirthDetails = async () => {


      try {
        const res = await axios.get(
          `https://core-c343.onrender.com/api/birth-details?name=${userData.name}&sex=${userData.gender}&location=${userData.city}&year=${userData.year}&month=${userData.month}&day=${userData.day}&hour=${userData.hour}&minute=${userData.minute}`
        );

        const data = res.data;
        const p = data.personalDetails;
        const a = data.avkahadaChakra;
        const f = data.favourablePoints;
        const g = data.ghatakMalefics;

        setPersonDetails([
          { label: "Sex", value: p.sex },
          { label: "Date of Birth", value: p.dateOfBirth },
          { label: "Time of Birth", value: p.timeOfBirth },
          { label: "Day of Birth", value: p.dayOfBirth },
          { label: "Ishtkaal", value: p.ishtkaal },
          { label: "Place of Birth", value: p.placeOfBirth },
          { label: "Country", value: p.country },
          { label: "Time Zone", value: p.timeZone },
          { label: "Latitude", value: p.latitude },
          { label: "Longitude", value: p.longitude },
          { label: "Sunrise", value: p.sunrise },
          { label: "Sunset", value: p.sunset }
        ]);

        setAvkahadaChakra([
          { label: "Paya (Nakshatra Based)", value: a.paya },
          { label: "Varna", value: a.varna },
          { label: "Yoni", value: a.yoni },
          { label: "Gana", value: a.gana },
          { label: "Vasya", value: a.vasya },
          { label: "Nadi", value: a.nadi },
          { label: "Balance Of Dasha", value: a.balanceOfDasha },
          //{ label: "Rasi Lord", value: a.rasiLord },
          { label: "Rasi", value: a.rasi },
          { label: "Nakshatra Pada", value: a.nakshatraPada },
          { label: "Nakshatra Lord", value: a.nakshatraLord },
          { label: "Rasi Lord", value: a.rasiLord }
        ]);

        setFavourablePoints([
          { label: "Lucky Numbers", value: f.luckyNumbers?.join(", ") },
          { label: "Good Numbers", value: f.goodNumbers?.join(", ") },
          { label: "Evil Numbers", value: f.evilNumbers?.join(", ") },
          { label: "Good Years", value: f.goodYears?.join(", ") },
          { label: "Lucky Days", value: f.luckyDays?.join(", ") },
          { label: "Good Planets", value: f.goodPlanets?.join(", ") },
          { label: "Friendly Signs", value: f.friendlySigns?.join(", ") },
          { label: "Good Lagna", value: f.goodLagna?.join(", ") },
          { label: "Lucky Metal", value: f.luckyMetal },
          { label: "Lucky Stone", value: f.luckyStone }
        ]);

        setGhatakMalefics([
          { label: "Bad Day", value: g.badDay },
          { label: "Bad Month", value: g.badMonth },
          { label: "Bad Lagna", value: g.badLagna },
          { label: "Bad Karan", value: g.badKaran },
          { label: "Bad Nakshatra", value: g.badNakshatra },
          { label: "Bad Tithi", value: g.badTithi },
          { label: "Bad Rasi", value: g.badRasi },
          { label: "Bad Prahar", value: g.badPrahar },
          { label: "Bad Yoga", value: g.badYoga },
          { label: "Bad Planets", value: g.badPlanets?.join(", ") }
        ]);

        setLoading(false);
      } catch (error) {
        console.error("Failed to fetch birth details:", error);
        setLoading(false);
      }
    };

    fetchBirthDetails();
  }, []);

  return (
    <div className="basic-details-container">
      <InnerNav />
      <h2>Basic Details</h2>

      {loading ? (
        <p>Loading birth details...</p>
      ) : (
        <div className="card-wrapper">
          <div className="details-card">
            <div className="card-header">Person Details</div>
            <table>
              <tbody>
                {personDetails.map((item, index) => (
                  <tr key={index}>
                    <td>{item.label}</td>
                    <td>{item.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="details-card">
            <div className="card-header">Avkahada Chakra</div>
            <table>
              <tbody>
                {avkahadaChakra.map((item, index) => (
                  <tr key={index}>
                    <td>{item.label}</td>
                    <td>{item.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="details-card">
            <div className="card-header">Favourable Points</div>
            <table>
              <tbody>
                {favourablePoints.map((item, index) => (
                  <tr key={index}>
                    <td>{item.label}</td>
                    <td>{item.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="details-card">
            <div className="card-header">Ghatak Malefics</div>
            <table>
              <tbody>
                {ghatakMalefics.map((item, index) => (
                  <tr key={index}>
                    <td>{item.label}</td>
                    <td>{item.value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default BasicDetails;
